import { CheckCircle2, CircleDollarSign, MinusCircle, MinusSquare } from "lucide-react";

// Read-only paid/unpaid indicator sourced ONLY from the target/receiver GL
// (Prompt 05c). Before the bill exists in target we show "Not in GL yet" —
// never mirroring the sender's paid/unpaid. Pipe status (Held/Ready/Synced/
// Failed) is handled separately by StatusPill.
export default function PaymentPill({ invoice }) {
  const ps = (invoice.payment_status || "not_in_gl").toLowerCase();
  const map = {
    paid:       { label: "Paid",          cls: "bg-emerald-50 text-emerald-900 border-emerald-300", Icon: CheckCircle2 },
    partial:    { label: "Partial",       cls: "bg-amber-50 text-amber-900 border-amber-300",       Icon: MinusCircle },
    unpaid:     { label: "Unpaid",        cls: "bg-neutral-100 text-neutral-800 border-neutral-300",Icon: CircleDollarSign },
    not_in_gl:  { label: "Not in GL yet", cls: "bg-neutral-50 text-neutral-500 border-neutral-200", Icon: MinusSquare },
  };
  const { label, cls, Icon } = map[ps] || map.not_in_gl;
  return (
    <div className={`inline-flex items-center gap-1 px-2 py-1 border text-xs uppercase tracking-widest ${cls}`}
         data-testid={`payment-pill-${invoice.invoice_number || invoice.id}`}
         data-payment={ps}>
      <Icon size={10} /> {label}
    </div>
  );
}
